import { render, staticRenderFns } from "./InfiniteScrollList.vue?vue&type=template&id=f874e3b8&scoped=true"
import script from "./InfiniteScrollList.vue?vue&type=script&lang=ts"
export * from "./InfiniteScrollList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f874e3b8",
  null
  
)

export default component.exports